
import httpClient from './httpClient';


const getUserDetails = (userId) => httpClient.get('/api/v2/Account/GetConfig', { params: { userId: JSON.stringify(userId) } });


const getTenant = () => httpClient.get('/api/v2/Account/GetTenant');

const getTimezone = () => httpClient.get('/api/v2/Utilities/GetTimezone');

const getVersion = () => httpClient.get('/api/v2/Account/GetVersion');


const getMaintenanceStatus = () => httpClient.get('/api/v2/Maintenance/GetMaintenanceStatus');

const getActiveLocation = (location) => httpClient.post('/api/v2/Account/ActiveLocation', { activelocation: location });

const displayCurrencyAmount = (amount, propertyId) => httpClient.get('/api/v2/PropertyCurrency/DisplayCurrencyAmount', { params: { amount: amount, propertyId: propertyId } });




const getMonths = () => {
  return [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' },
  ];
};

const getWeekdays = () => {
  return [
    { id: 1, name: 'Sunday' },
    { id: 2, name: 'Monday' },
    { id: 3, name: 'Tuesday' },
    { id: 4, name: 'Wednesday' },
    { id: 5, name: 'Thursday' },
    { id: 6, name: 'Friday' },
    { id: 7, name: 'Saturday' }
  ];
}

const getYears = () => {
  const nextYear = new Date().getFullYear() + 1;
  let years = [];

  for (var i = 0; i < 4; i++) {
    let value = nextYear - i;

    years.push({
      id: value,
      name: value
    });
  }

  return years;
}

const getApiConfig = () => httpClient.get('/Account/GetApiConfig');


const initialRoomStay = () => {

  return {
    id: 0,
    roomTypeId: 0,
    currencyId: 0,
    adults: 0,
    children: 0,
    breakfast: 0,
    startDate: null,
    endDate: null,
    roomId: 0,
    bedId: 0,
    roomStayGuestId: 0,
    remarks: "",
    roomStayStatusId: 0,
    chargeList: []
  }

};

const initialCharge = () => {
  return {
    date: null,
    amount: null
  }
}

const initialBooking = () => {
  return {
    id: 0,
    propertyId: 0,
    guest: null,
    bookingTypeValue: null,
    startDate: null,
    endDate: null,
    isCancellation: false,
    orderDateTime: new Date(),
    cancellationDate: null,
    cancellationReason: "",
    note: "",
    arrivalTime: "",
    bookingStatusId: "",
    createdDate: new Date(),
    createdUser: 0,
    corporateId: 0,
    roomStays: [],
    bookingChannelsId: 0,
    paymentCollect: 1,
    orderCode: ''
  }
}

export default {
  getUserDetails,
  getActiveLocation,
  getMonths,
  getWeekdays,
  getYears,
  getApiConfig,
  initialRoomStay,
  initialCharge,
  initialBooking,
  getTenant,
  getVersion,
  displayCurrencyAmount,
  getTimezone,
  getMaintenanceStatus
};



// WEBPACK FOOTER //
// ./src/api/utilities-api.js